import request from "@utils/request";

/*
 *
 * */
export function getZiXun() {
  return request.get("mer_info", {}, { login: false });
}

/*
 * 商品分类
 * */
export function getCategory() {
  return request.get("/category", {}, { login: false });
}
/*
 * 商品分类2
 * */
export function getCategory2() {
  return request.get("/category2", {}, { login: false });
}
export function getvipCategory(data) {
  return request.get("/getvipCategory/" + data, {}, { login: false });
}

/*
 * 积分商城
 * */
export function getIntegralCategory() {
  return request.get("/integral_category", {}, { login: false });
}

/*
 * 积分商城2
 * */
export function getIntegralIndex() {
  // return request.get("/integral_index", {}, { login: false });
  return request.get("/integral_index_new", {}, { login: false });
}

/*
 * 商品详情
 * */
export function getProductDetail(q) {
  return request.get("/product/detail/" + q, {}, { login: false });
}

/*
 * 商品分销二维码
 * */
export function getProductCode(id) {
  return request.get("/product/code/" + id, {}, { login: true });
}

/*
 * 商品列表
 * */
export function getProducts(q) {
  return request.get("/products", q, { login: false });
}

/*
 * 积分商城_商品列表
 * */
export function getIntegralProducts(q) {
  return request.get("/integral_products", q, { login: false });
}
/*
 * 积分商城_VIP商品列表
 * */
export function getIntegralVipProducts(q) {
  return request.get("/vip_products", q, { login: false });
}
/*
 * 积分商城_支付
 * */
export function getIntegralPay(data) {
  return request.get("/integral_pay", data, { login: false });
}

/*
 * 购物车数量
 * */
export function getCartNum() {
  return request.get("/cart/count");
}

/*
 * 添加收藏
 * */
export function toCollect(id, category) {
  return request.get("/collect/add/" + id + "/" + category);
}

/*
 * 为你推荐
 * */
export function getHostProducts(page, limit) {
  return request.get(
    "/product/hot",
    { page: page, limit: limit },
    { login: false }
  );
}

/*
 * 精品、热门、首发列表
 * */
export function getGroomList(type) {
  return request.get("/groom/list/" + type, {}, { login: false });
}

/*
 * 购物车 添加
 * */
export function postCartAdd(data) {
  return request.post("/cart/add", data);
}

/*
 * 购物车列表
 * */
export function getCartList(data) {
  return request.get("/cart/list", data);
}

/*
 * 购物车 删除
 * */
export function postCartDel(ids) {
  return request.post("/cart/del", { ids });
}

/*
 * 购物车 获取数量
 * */
export function getCartCount(data) {
  return request.get("/cart/count", data);
}

/*
 * 购物车 修改商品数量
 * */
export function changeCartNum(id, number) {
  return request.post("/cart/num", { id, number });
}

/**
 * 搜索推荐关键字
 */
export function getSearchKeyword() {
  return request.get("/search/keyword", {}, { login: false });
}

/**
 * 产品评论列表
 */
export function getReplyList(id, q) {
  return request.get("/reply/list/" + id, q, { login: false });
}

/**
 * 产品评价数量和好评度
 */
export function getReplyConfig(id) {
  return request.get("/reply/config/" + id, {}, { login: false });
}

/**
 * 评价页面获取单个产品详情
 */
export function postOrderProduct(unique) {
  return request.post("/order/product", { unique }, { login: false });
}

/**
 * 提交评价页面；
 */
export function postOrderComment(data) {
  return request.post("/order/comment", data, { login: false });
}

/**
 * 获取2级商品分类；
 */
export function getGoodList(data) {
  return request.get("/products", data, { login: false });
}

export function getProductHot(page, limit) {
  return request.get(
    "product/hot",
    {
      page: page === undefined ? 1 : page,
      limit: limit === undefined ? 4 : limit
    },
    {
      noAuth: true
    }
  );
}
export function collectAll(id, category) {
  return request.post("collect/all", {
    id: id,
    category: category === undefined ? "product" : category
  });
}
export function formnethosp(data) {
  // console.log(data+"1")
  // return false;
  return request.post("nethosp", data);
}
export function getnethosp(data) {
  return request.post("getnethosp", { rpId: data });
}
